<template>
<div class="denom-table">
  <table class="table table-responsive">
    <thead v-if="header">
      <tr>
        <th v-for="(c, k) in columns" :key="`${c.key}-${k}`"><span v-html="c.title"></span></th>
      </tr>
    </thead>
    <tbody>
      <tr :class="warning ? `tr-main tr-${warning.type}` : ''">
        <td v-for="(c, k) in columns" :key="`${c.key}-${k}-value`">
          <span v-if="c.value != null" v-html="c.value"></span>
          <span v-else-if="denoms[c.key] === '-1'" class="list">
            <span>
              <cleave class="form-control text-center"
                      autocomplete="off" disabled
                      name="numeric" value="Non connu">
              </cleave>
            </span>
            <btn type="success" @click="denoms[c.key] = null" size="xs">
              NR
            </btn>
          </span>
          <span v-else>
            <div class="hoverable">
              <span @mouseover="tooltips[c.key] = true"
                    @mouseleave="tooltips[c.key] = false"
                    @click="tooltips[c.key] = true"
                    class="list">
                <cleave v-model="denoms[c.key]"
                        :class="`cell-${warning.tooltips[c.key].type}`"
                        class="form-control text-center cell"
                        @blur="tooltips[c.key] = false"
                        :options="c.nr ? options.nr : options.std"
                        autocomplete="off"
                        name="numeric">
                </cleave>
                <btn type="warning" @click="setNA(c.key)" size="xs"
                     v-if="c.nr">
                  NR
                </btn>
              </span>
              <div v-if="warning.tooltips[c.key].type !== 'default'"
                   v-show="tooltips[c.key]" class="tooltip-container">
                <div class="tooltip bottom fade in"
                  :class="`tooltip-${warning.tooltips[c.key].type}`">
                  <div class="tooltip-arrow"></div>
                  <div class="tooltip-inner">
                    <span v-html="warning.tooltips[c.key].msg"></span>
                  </div>
                </div>
              </div>

            </div>
          </span>
        </td>
      </tr>
      <tr v-if="warning" :class="`tr-sub tr-${warning.type}`">
        <td :colspan="columns.length">
          <strong>
            <span v-html="warning.text"></span>
          </strong>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import cleave from 'vue-cleave-component'
import assert from '@/sui/tools/assert'

const genericThresholds = [
  { key: 'adm', l1: 1, l2: 2, h2: 20000, h1: 100000 },
  { key: 'bed', l1: 1, l2: 2, h2: 3000, h1: 10000 },
  { key: 'cart', l1: 1, l2: 10, h2: 3000, h1: 10000 },
  { key: 'caut', l1: 1, l2: 1, h2: 1000, h1: 10000 },
  { key: 'cci', l1: 1, l2: 1, h2: 3000, h1: 10000 },
  { key: 'cdia', l1: 1, l2: 2, h2: 7500, h1: 30000 },
  { key: 'chi', l1: 1, l2: 1, h2: 20000, h1: 50000 },
  { key: 'cvc', l1: 1, l2: 3, h2: 3000, h1: 10000 },
  { key: 'cvo', l1: 1, l2: 2, h2: 1000, h1: 10000 },
  { key: 'file', l1: 1, l2: 2, h2: 2000, h1: 10000 },
  { key: 'fnat', l1: 1, l2: 10, h2: 10000, h1: 30000 },
  { key: 'fpro', l1: 1, l2: 1, h2: 750, h1: 3000 },
  { key: 'itb', l1: 1, l2: 2, h2: 3000, h1: 10000 },
  { key: 'jh', l1: 1, l2: 10, h2: 10000, h1: 100000 },
  { key: 'jhi', l2: 100, h2: 30000 },
  { key: 'picc', l1: 1, l2: 1, h2: 1000, h1: 3000 },
  { key: 'sea', l1: 12, l2: 20, h2: 75000, h1: 300000 }
]

const alertTable = [
  {
    codes: ['AD CAN', 'AD HEM'],
    thresholds: [
      { key: 'adm', l1: 15, l2: 21, h2: 4501, h1: 10000 },
      { key: 'bed', l1: 0, l2: 4, h2: 97, h1: 150 },
      { key: 'chi', l1: 0, l2: 6, h2: 11575, h1: 15000 },
      { key: 'jh', l1: 100, l2: 100, h2: 8136, h1: 10000 },
      { key: 'jh/adm', l1: 0, l2: 0, h2: 1.54, h1: 2 },
      { key: 'jh/bed', l1: 0.7, l2: 0.9, h2: 2.29, h1: 2.6 },
      { key: 'adm/bed', l1: -0.15, l2: -0.03, h2: 2.18, h1: 2.5 },
      { key: 'chi/jh', l1: -2.3, l2: -2.3, h2: 0.92, h1: 1 },
      { key: 'chi/adm', l1: -1.5, l2: -1.5, h2: 1.77, h1: 2 },
      { key: 'chi/bed', l1: -1.5, l2: -0.53, h2: 2.62, h1: 2.85 },
      { key: 'jhi/bed', l2: -1.5, h2: 2.5 }
    ]
  },
  {
    codes: ['AD RAD'],
    thresholds: []
  },
  {
    codes: ['AD MED'],
    thresholds: [
      { key: 'adm', l1: 5, l2: 19, h2: 11669, h1: 30000 },
      { key: 'bed', l1: 0, l2: 6, h2: 515, h1: 1000 },
      { key: 'chi', l1: 0, l2: 2, h2: 4418, h1: 50000 },
      { key: 'jh', l1: 80, l2: 154, h2: 42904, h1: 100000 },
      { key: 'sea', l1: 0, l2: 11, h2: 9418, h1: 50000 },
      { key: 'jh/adm', l1: 0, l2: 0.01, h2: 1.7, h1: 2.3 },
      { key: 'jh/bed', l1: 0, l2: 1, h2: 2.27, h1: 2.75 },
      { key: 'adm/bed', l1: -0.3, l2: 0.12, h2: 1.9, h1: 2.3 },
      { key: 'chi/jh', l1: -5, l2: -4.04, h2: 0.11, h1: 3 },
      { key: 'chi/adm', l1: -5, l2: -3.13, h2: 0.71, h1: 3 },
      { key: 'chi/bed', l1: -4, l2: -2.13, h2: 2.03, h1: 4 },
      { key: 'jhi/bed', l1: -2, l2: -0.589, h2: 1.89, h1: 2.5 }
    ]
  },
  {
    codes: ['AD CHIR'],
    thresholds: [
      { key: 'adm', l1: 30, l2: 106, h2: 7760, h1: 15000 },
      { key: 'bed', l1: 6, l2: 11.1, h2: 286, h1: 600 },
      { key: 'jh', l1: 350, l2: 478, h2: 20700, h1: 30000 },
      { key: 'ven', l1: 20, l2: 135, h2: 12600, h1: 30000 },
      { key: 'jhi', l1: 20, l2: 135, h2: 12600, h1: 30000 },
      { key: 'jh/adm', l1: 0, l2: 0.154, h2: 0.944, h1: 1 },
      { key: 'jh/bed', l1: 0.8, l2: 1.4, h2: 2.11, h1: 2.6 },
      { key: 'adm/bed', l1: 0.2, l2: 0.773, h2: 1.63, h1: 2 },
      { key: 'ven/jh', l1: -2.3, l2: -1.37, h2: 0.562, h1: 0.8 },
      { key: 'ven/adm', l1: -1.1, l2: -0.818, h2: 1.06, h1: 1.1 },
      { key: 'ven/bed', l1: -0.3, l2: 0.591, h2: 2.04, h1: 2.3 },
      { key: 'jhi/jh', l1: -2.3, l2: -1.37, h2: 0.562, h1: 0.8 },
      { key: 'jhi/adm', l1: -1.1, l2: -0.818, h2: 1.06, h1: 1.1 },
      { key: 'jhi/bed', l1: -0.3, l2: 0.591, h2: 2.04, h1: 2.3 }
    ]
  },
  {
    codes: ['AD REA'],
    thresholds: [
      { key: 'adm', l1: 0, l2: 5, h2: 436, h1: 1000 },
      { key: 'bed', l1: 0, l2: 5, h2: 30, h1: 100 },
      { key: 'jh', l1: 150, l2: 150, h2: 2430, h1: 3000 },
      { key: 'jh/adm', l1: 0, l2: 0.43, h2: 1.87, h1: 2 },
      { key: 'jh/bed', l1: 1.3, l2: 1.3, h2: 2.3, h1: 2.3 },
      { key: 'adm/bed', l1: 0, l2: 0, h2: 1.46, h1: 1.7 }
    ]
  },
  {
    codes: ['AD DIA'],
    thresholds: [
      { key: 'adm', l2: 1, h2: 7087 },
      { key: 'bed', l2: 8, h2: 150 },
      { key: 'sea', l2: 363, h2: 56514 },
      { key: 'sea/adm', l2: 0, h2: 3 },
      { key: 'sea/bed', l2: 1.5, h2: 2.5 },
      { key: 'adm/bed', l2: -1.34, h2: 2.31 }
    ]
  },
  {
    codes: ['AD EHP', 'AD SLD'],
    thresholds: [
      { key: 'adm', l1: 1.33, l2: 1.33, h2: 94.4, h1: 750 },
      { key: 'bed', l1: 11, l2: 11, h2: 561, h1: 800 },
      { key: 'jh', l1: 300, l2: 712, h2: 48500, h1: 120000 },
      { key: 'jh/adm', l1: 0.699, l2: 2.06, h2: 3.48, h1: 4.08 },
      { key: 'jh/bed', l1: 1.08, l2: 1.81, h2: 2.02, h1: 2.3 },
      { key: 'adm/bed', l1: -2.3, l2: -1.58, h2: -0.163, h1: 0.0414 }
    ]
  }
]

for (let i = 0; i !== alertTable.length; ++i) {
  const al = alertTable[i]
  for (let j = 0; j !== genericThresholds.length; ++j) {
    const gt = genericThresholds[j]
    if (al.thresholds.find(e => e.key === gt.key) == null) {
      al.thresholds.push(gt)
    }
  }
}
alertTable.push({ codes: [''], thresholds: genericThresholds })

const ufAlertTable = []
for (let i = 0; i !== alertTable.length; ++i) {
  const alert = alertTable[i]
  const thresholds = []
  for (let i = 0; i !== alert.thresholds.length; ++i) {
    const t = alert.thresholds[i]
    const copy = {
      key: t.key,
      l1: t.l1,
      l2: t.l2,
      h2: t.h2,
      h1: t.h1,
      admInterSit: t.admInterSit,
      bedInterSit: t.bedInterSit,
      seaInterSit: t.seaInterSit
    }

    if (!t.key.includes('/')) {
      copy.l1 = copy.l2 = 0
    }

    thresholds.push(copy)
  }

  ufAlertTable.push(
    {
      codes: alert.codes.slice(),
      thresholds: thresholds
    }
  )
}

function singleAlertMessage (text) {
  assert.notNull(text)
  return (s) => `Le nombre ${text} semble ${s}.`
}

function ratioAlertMessage (prefix, suffix) {
  assert.notNull(prefix)
  assert.notNull(suffix)
  return (s) => `Le nombre ${prefix} semble ${s} par rapport au nombre ${suffix}.`
}

const alertTexts = {
  adm: `d'admissions`,
  bed: `de lits surveillés`,
  sea: `de séances de dialyse`,
  chi: `de séances de chimiothérapie`,
  jh: `de journées d'hospitalisation complètes`,
  jhi: `de journées d'hospitalisation incomplètes`,
  ven: `de venues`,
  cart: `de cathéters artériels`,
  caut: `d'autres cathéters`,
  cci: `de CCI`,
  cdia: `de cathéters de dialyse`,
  cvc: `de CVC`,
  cvo: `de CVO`,
  file: `de patients dans la file active`,
  fnat: `de fistules natives`,
  fpro: `de fistules prothèse`,
  itb: `de porteurs de ventilation mécanique`,
  picc: `de PICC`
}

const alertMessages = {
  adm: singleAlertMessage(alertTexts.adm),
  bed: singleAlertMessage(alertTexts.bed),
  sea: singleAlertMessage(alertTexts.sea),
  chi: singleAlertMessage(alertTexts.chi),
  jh: singleAlertMessage(alertTexts.jh),
  jhi: singleAlertMessage(alertTexts.jhi),
  ven: singleAlertMessage(alertTexts.ven),
  cart: singleAlertMessage(alertTexts.cart),
  caut: singleAlertMessage(alertTexts.caut),
  cci: singleAlertMessage(alertTexts.cci),
  cdia: singleAlertMessage(alertTexts.cdia),
  cvc: singleAlertMessage(alertTexts.cvc),
  cvo: singleAlertMessage(alertTexts.cvo),
  file: singleAlertMessage(alertTexts.file),
  fnat: singleAlertMessage(alertTexts.fnat),
  fpro: singleAlertMessage(alertTexts.fpro),
  itb: singleAlertMessage(alertTexts.itb),
  picc: singleAlertMessage(alertTexts.picc),
  'jh/adm': ratioAlertMessage(alertTexts.jh, alertTexts.adm),
  'jh/bed': ratioAlertMessage(alertTexts.jh, alertTexts.bed),
  'adm/bed': ratioAlertMessage(alertTexts.adm, alertTexts.bed),
  'sea/bed': ratioAlertMessage(alertTexts.sea, alertTexts.bed),
  'sea/adm': ratioAlertMessage(alertTexts.sea, alertTexts.adm),
  'chi/jh': ratioAlertMessage(alertTexts.chi, alertTexts.jh),
  'chi/adm': ratioAlertMessage(alertTexts.chi, alertTexts.adm),
  'chi/bed': ratioAlertMessage(alertTexts.chi, alertTexts.bed),
  'ven/jh': ratioAlertMessage(alertTexts.ven, alertTexts.jh),
  'ven/adm': ratioAlertMessage(alertTexts.ven, alertTexts.adm),
  'ven/bed': ratioAlertMessage(alertTexts.ven, alertTexts.bed),
  'jhi/jh': ratioAlertMessage(alertTexts.jhi, alertTexts.jh),
  'jhi/adm': ratioAlertMessage(alertTexts.jhi, alertTexts.adm),
  'jhi/bed': ratioAlertMessage(alertTexts.jhi, alertTexts.bed)
}

function checkAlertMessages () {
  for (let i = 0; i !== alertTable.length; ++i) {
    const alert = alertTable[i]
    for (let j = 0; j !== alert.thresholds.length; ++j) {
      const t = alert.thresholds[j]
      assert.notNull(alertMessages[t.key])
    }
  }
}
checkAlertMessages()

function alertTrigger (d, t) {
  if (t.l1 != null && d < t.l1) {
    return [1, 'trop bas']
  }

  if (t.h1 != null && d > t.h1) {
    return [1, 'trop élevée']
  }

  if (d < t.l2) {
    return [0.5, 'bas']
  }

  if (t.h2 < d) {
    return [0.5, 'élevé']
  }

  return null
}

function setTooltip (tooltip, index, title, msg, priority) {
  tooltip.index += index
  if (priority > tooltip.priority) {
    tooltip.priority = priority
    tooltip.msg = `${msg}`
  }
}

function setTooltipStyle (tooltip) {
  if (tooltip.index >= 1) {
    tooltip.type = 'danger'
    return
  }

  if (tooltip.index >= 0.5) {
    tooltip.type = 'warning'
    return
  }

  if (tooltip.index > 0) {
    tooltip.type = 'info'
  }
}

function setTooltipFromRatio (tooltip, num, div, threshold) {
  if (threshold == null) {
    return
  }

  const ratio = Math.log10(num / div)
  setTooltipFromThreshold(tooltip, ratio, threshold)
}

function setTooltipFromThreshold (tooltip, value, threshold) {
  if (threshold == null) {
    return
  }

  const alert = alertTrigger(value, threshold)
  if (alert == null) {
    return
  }

  setTooltip(
    tooltip, alert[0], 'Attention !', alertMessages[threshold.key](alert[1]),
    2
  )
}

export default {
  name: 'denom-table',

  props: {
    header: {
      type: Boolean,
      default: true
    },

    columns: {
      required: true,
      type: Array
    },

    value: {
      required: true,
      type: Object
    },

    checker: {
      type: Function,
      required: false
    },

    optional: {
      type: Boolean,
      default: false
    },

    code: {
      type: String,
      required: true
    },

    module: {
      type: String,
      required: true
    }
  },

  data: function () {
    const denoms = {}
    const tooltips = {}
    this.columns.forEach(
      u => {
        if (u.value == null) {
          denoms[u.key] = null
        }
        tooltips[u.key] = false
      }
    )

    for (let v in this.value) {
      denoms[v] = this.value[v]
    }

    return {
      options: {
        std: {
          numeral: true,
          numeralThousandsGroupStyle: 'none',
          numeralPositiveOnly: true
        },

        nr: {
          numeral: true,
          numeralThousandsGroupStyle: 'none'
        }
      },

      denoms: denoms,
      tooltips,
      watchers: []
    }
  },

  methods: {
    setNA: function (key) {
      this.denoms[key] = '-1'
    }
  },

  created: function () {
    this.watchers.forEach(w => w())
    this.watchers = []

    this.columns.forEach(
      u => {
        if (u.edit != null) {
          this.watchers.push(
            this.$watch(
              `denoms.${u.key}`,
              (n, o) => {
                u.edit(n, o, this.denoms, this.columns)
              }
            )
          )
        }
      }
    )
  },

  computed: {
    ufColumn: function () {
      return this.columns.find(c => c.key === 'uf')
    },

    thresholds: function () {
      const hasUf = this.ufColumn
      const alerts = hasUf ? ufAlertTable : alertTable
      const result = alerts.find(
        alert => alert.codes.find(c => this.code.startsWith(c)) != null
      )

      return result.thresholds
    },

    warning: function () {
      const zeroAlert = ['jh', 'jhi', 'adm', 'bed']
      const duplicateAlert = ['jh', 'adm', 'bed', 'sea', 'chi', 'ven', 'jhi']
      const duplicateAlertKey = [
        'jh.adm', 'jh.bed', 'jh.sea', 'jh.chi', 'jh.ven', 'jh.jhi',
        'adm.bed', 'adm.chi', 'adm.ven', 'adm.jhi',
        'bed.sea', 'bed.chi', 'bed.ven', 'bed.jhi',
        'sea.chi', 'sea.ven', 'sea.jhi',
        'chi.ven', 'chi.jhi',
        'ven.jhi'
      ]

      const tooltips = {}
      const ufc = this.ufColumn
      let countKey = this.code
      if (ufc != null) {
        countKey = `${countKey}-${ufc.value}`
      }

      const counts = {
        total: 0,
        alert: 0,
        missing: 0,
        key: countKey
      }

      for (let i = 0; i < this.columns.length; ++i) {
        const c = this.columns[i]
        if (c.value != null) {
          continue
        }

        const d = parseInt(this.denoms[c.key])
        if (c.nr && d === -1) {
          continue
        }
        const tooltip = {
          type: 'default',
          msg: '',
          index: 0,
          priority: -1
        }
        counts.total++

        if (isNaN(d)) {
          if (!this.optional) {
            setTooltip(
              tooltip, 1, 'Attention !',
              'La saisie de ce champ est obligatoire.', 10
            )
            counts.missing++
          }
        } else if (d === -1 || d === 0) {
          setTooltip(
            tooltip, 0.01, 'Remarque',
            `Les taux d'incidences des dénominateurs à 0 ou «Non renseigné» ne seront pas calculés.`,
            1
          )
          counts.missing++
        } else if (this.thresholds) {
          const threshold = this.thresholds.find(limit => limit.key === c.key)
          setTooltipFromThreshold(tooltip, d, threshold)
        }

        const zero = zeroAlert.includes(c.key)
        const duplicate = duplicateAlert.includes(c.key)
        if (this.thresholds != null || zero || duplicate) {
          for (let j = 0; j < this.columns.length; ++j) {
            const v = this.columns[j]
            if (v.value != null || c.key === v.key) {
              continue
            }

            const e = parseInt(this.denoms[v.key])
            if (this.thresholds != null && d > 0 && e > 0) {
              const keyN = `${c.key}/${v.key}`
              const thresholdN = this.thresholds.find(
                limit => limit.key === keyN
              )
              setTooltipFromRatio(tooltip, d, e, thresholdN)

              const keyD = `${v.key}/${c.key}`
              const thresholdD = this.thresholds.find(
                limit => limit.key === keyD
              )
              setTooltipFromRatio(tooltip, e, d, thresholdD)
            }

            if (zero && d === 0 && !isNaN(e) && e !== 0) {
              setTooltip(
                tooltip, 1, 'Attention !',
                `Zéro est incohérent avec les autres dénominateurs saisis.
               <p>Les taux d'incidences des dénominateurs à 0 ou «Non renseigné» ne seront pas calculés.</p>`,
                2
              )
            }

            if (duplicate) {
              const test = duplicateAlertKey.includes(`${v.key}.${c.key}`) ||
                           duplicateAlertKey.includes(`${c.key}.${v.key}`)
              if (test && d !== 0 && !isNaN(d) && d === e) {
                setTooltip(
                  tooltip, 1, 'Attention !',
                  'Plusieurs dénominateurs ont des valeurs identiques.', 50
                )
              }
            }
          }
        }
        setTooltipStyle(tooltip)
        tooltips[c.key] = tooltip
        if (tooltip.index >= 0.5) {
          counts.alert++
        }
      }

      if (this.optional) {
        return {
          tooltips: tooltips,
          counts: counts,
          type: 'info',
          text: `Données d'activité optionnelles`
        }
      }

      return {
        tooltips,
        counts: counts
      }
    }
  },

  watch: {
    warning: {
      handler: function (v) {
        if (v != null && v.counts != null) {
          const vm = this
          this.$nextTick(() => vm.$emit('progress', v.counts))
        }
      },
      immediate: true
    },

    denoms: {
      handler (d) {
        this.$emit('input', d)
      },
      deep: true
    },

    value: {
      handler (d) {
        for (let v in d) {
          this.$set(this.denoms, v, d[v])
        }
      },
      deep: true
    }
  },

  components: {
    cleave
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~modules';

.denom-table {
  table {
    table-layout: fixed;
    margin-bottom: 0px;
  }

  th, td {
    text-align: center;
  }

  .list {
    display: flex;
    justify-content: space-around;

    .btn {
      margin-left: 0.2rem;
    }
  }

  .tr-sub {
    td {
      border-top-width: 0px;
      padding-top: 0rem;
      padding-bottom: 0rem;
    }
  }

  .tr-main {
    td {
      padding-bottom: 0.1rem;
    }
  }

  .tr-warning {
    background-color: @alert-warning-bg;
    color: @alert-warning-text;
  }

  .tr-danger {
    background-color: lighten(@brand-danger, 30%);
    color: darken(@brand-danger, 20%);
  }
  .tr-info {
    background-color: @alert-info-bg;
    color: @alert-info-text;
  }

  .cell {
    border: 0px;
  }

  .cell-danger {
    background-color: @brand-danger;
    color: white;
    font-weight: bold;
  }

  .cell-warning {
    background-color: @brand-warning;
    color: white;
    font-weight: bold;
  }

  .cell-info {
    &:extend(.bg-invalid);
    color: white;
    font-weight: bold;
  }

  .hoverable {
    position: relative;
  }

  .tooltip-container {
    justify-content: center;
    display: flex;

    .tooltip {
      font-weight: bold;
    }
  }
}
</style>
